import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationChurch = ({ denominationId, churchId }) => {
  return axios.get(
    `/denominations/${denominationId}/denomination-churches/${churchId}`
  );
};

export const useDenominationChurch = ({
  denominationId,
  churchId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["denomination-church", denominationId, churchId],
    queryFn: () => getDenominationChurch({ denominationId, churchId })
  });
};
